import PropTypes from "prop-types"
import Page from "components/Page"
import Wrapper from "components/Wrapper"
import ErrorMessage from "components/UI/ErrorMessage"
import Head from "next/head"

const Error = ({ statusCode }) => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <Page>
        <Wrapper>
          <ErrorMessage
            className="my-16"
            statusCode={statusCode}
            reloadButton
            homeButton
          />
        </Wrapper>
      </Page>
    </>
  )
}

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404
  return { statusCode }
}

Error.propTypes = {
  statusCode: PropTypes.number,
}

export default Error
